"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRegisteredShoppingList = void 0;
const routes_1 = require("../../routes");
const createRegisteredShoppingList = (client) => async (payload) => {
    const url = routes_1.ENDPOINTS.CREATE_REGISTERED_SHOPPING_LIST.path;
    const response = await client.post(url, payload, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.data;
};
exports.createRegisteredShoppingList = createRegisteredShoppingList;
